import Vue from 'vue';
import Vuetify, {UserVuetifyPreset} from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import light from '@client/plugins/theme';

const opts: Partial<UserVuetifyPreset> = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      light,
    },
  },
};

Vue.use(Vuetify);

export default new Vuetify(opts);
